import React from 'react';
import { type HeroImageV1 } from '@bbkAdminUtils/api-client/rest-modals-cards-types';
import { type ReactFCC } from '@bbkAdminUtils/utility-types';

type Props = {
  info: HeroImageV1;
};
export const ModalImage: ReactFCC<Props> = ({ info: img }) => (
  <div className="modal-image">
    <div className="MIContainer">
      <img src={img.url} alt="" className="image" />
    </div>
  </div>
);
